import { getStreamDetail, getAlumniStreamRecommendations, getAdvisorStreamRecommendations } from '../api'

export const loadStreamDetail = ({ state, commit }, uuid) => {
  return getStreamDetail(uuid).then(data => {
    if (data !== undefined) {
      commit('LOAD_STREAM', data)
    }
    return data
  })
}

export const loadAlumniStreamRecommendations = ({ state, commit }, {recommendationData}) => {
  return getAlumniStreamRecommendations(recommendationData).then(response => {
    commit('LOAD_ALUMNI_STREAM_RECOMMENDATIONS', response)
    return response
  })
}

export const loadAdvisorStreamRecommendations = ({ state, commit }, {recommendationData}) => {
  return getAdvisorStreamRecommendations(recommendationData).then(response => {
    commit('LOAD_ADVISOR_STREAM_RECOMMENDATIONS', response)
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/stream/vuex/actions.js